import { render, staticRenderFns } from "./TermGradesClass.vue?vue&type=template&id=e4ab64b2&scoped=true&"
import script from "./TermGradesClass.vue?vue&type=script&lang=js&"
export * from "./TermGradesClass.vue?vue&type=script&lang=js&"
import style0 from "./TermGradesClass.vue?vue&type=style&index=0&id=e4ab64b2&prod&lang=less&scoped=true&"
import style1 from "./TermGradesClass.vue?vue&type=style&index=1&id=e4ab64b2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ab64b2",
  null
  
)

export default component.exports